import {
  IError,
  IValues,
} from '../../types/interface/Assurance/assuranceScolaire';

import dayjs from 'dayjs';

export const TitleLabels = {
  contractant: {
    nomPrenomContractant: 'Nom et prénom(s) du Contractant ',
    telephoneContractant: 'Téléphone du Contractant',
    emailContractant: 'Email du Contractant',
    adresse: 'Adresse ',
    agence: 'Agence ARO (gestionaire du contrat)',
    primeTTC: 'Prime TTC à payer (en Ariary)',
    dateNaissanceContractant: 'Date de naissance du contractant',
    dateEffet: "Date d'effet",
  },
  eleveAssure: {
    nomPrenomEleveAssure: "Nom et prénom(s) de l'Eleve assuré ",
    dateNaissanceEleveAssure: "Date de naissance de l'Eleve assuré ",
    etablissementScolaire: 'Etablissement scolaire',
    anneeScolaire: 'Année scolaire (aaaa - aaaa)',
  },
};

export const showErrorValuesDefault = {
  nomPrenomContractant: false,
  telephoneContractant: false,
  emailContractant: false,
  dateNaissanceContractant: false,
  adresse: false,
  agence: false,
  primeTTC: false,
  nomPrenomEleveAssure: false,
  dateNaissanceEleveAssure: false,
  etablissementScolaire: false,
  anneeScolaire: false,
  dateEffet: false,
};
export const showErrorValuesSubmit = {
  nomPrenomContractant: true,
  telephoneContractant: true,
  emailContractant: true,
  dateNaissanceContractant: true,
  adresse: true,
  agence: true,
  primeTTC: true,
  nomPrenomEleveAssure: true,
  dateNaissanceEleveAssure: true,
  etablissementScolaire: true,
  anneeScolaire: true,
  dateEffet: true,
};

export const defaultErrorValues: IError = {
  nomPrenomContractant: '',
  telephoneContractant: '',
  emailContractant: '',
  dateNaissanceContractant: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  nomPrenomEleveAssure: '',
  dateNaissanceEleveAssure: '',
  etablissementScolaire: '',
  anneeScolaire: '',
  is_recurrent: '',
  dateEffet: '',
};

export const defaultValues: IValues = {
  nomPrenomContractant: '',
  telephoneContractant: '',
  telephoneContractantCountryCode: '',
  emailContractant: '',
  dateNaissanceContractant: '',
  adresse: '',
  agence: '',
  primeTTC: '',
  nomPrenomEleveAssure: '',
  dateNaissanceEleveAssure: '',
  etablissementScolaire: '',
  anneeScolaire: '',
  is_recurrent: false,
  dateEffet: dayjs().startOf('day').format('DD/MM/YYYY'),
};
